<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUIStore } from '@/stores/ui'

const userStore = useUserStore()

const uiStore = useUIStore()

const { isCollapsed } = storeToRefs(uiStore)

function onCommand(command: string) {
  switch (command) {
    case 'logout': {
      userStore.logout()
      break
    }
    default:
      break
  }
}
</script>

<template>
  <div h-16 px-4 flex items-center justify-between border-base b-b>
    <div flex items-center gap-4>
      <div
        i-ep-fold h-5 w-5 hover:bg-primary transition-200 :class="isCollapsed ? 'rotate-0' : 'rotate--180'"
        @click="uiStore.toggleAppSidebar"
      />
      <div class="text-3.5 text-#303133">
        首页
      </div>
    </div>

    <div flex items-center>
      <!-- <SwaggerDocsButton v-if="userStore.userRole.level === 0" /> -->
      <div px-3 flex items-center gap-2>
        <div class="w-32px h-32px rounded-50% bg-blue flex-center hover:bg-blue-500">
          <div i-ep-avatar text-white w-4 h-4 />
        </div>
        <client-only>
          <el-dropdown @command="onCommand">
            <div flex items-center>
              <div>{{ userStore.user?.username }}({{ userStore.user?.role.name }})</div>
              <div i-ep-arrow-down w-3 h-3 />
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="logout">
                  注销
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </client-only>
      </div>
    </div>
  </div>
</template>
